<template>
  <!-- 面试邀请弹窗 -->
  <div class="invite-box">
    <el-dialog
        :visible.sync="dialogVisible"
        append-to-body
        width="31%">
      <div class="g-text-center main-text g-font-20 g-font-weight-5">
        面试邀请
      </div>
      <div class="cut-line"></div>
      <div class="main-text g-font-20 g-font-weight-5">
       <!-- 蒙自吉祥口腔-->
      </div>
      <div class="g-m-t-15 g-flex input-row">
        <p class="label">联系人</p>
        <input class="input-area" v-model="name" placeholder="请输入联系人"></input>
      </div>
      <div class="g-m-t-15 g-flex input-row">
        <p class="label">联系电话</p>
        <input class="input-area" v-model="phone" placeholder="请输入联系电话"></input>
      </div>
      <div class="g-m-t-15 g-flex input-row">
        <p class="label">面试时间</p>
		<el-date-picker
		      v-model="time"
		      type="datetime"
			  class="input-area"
			  format="yyyy-MM-dd HH:mm:ss"
		      placeholder="选择日期时间">
		    </el-date-picker>
      </div>
      <div class="g-m-t-15 g-flex input-row">
        <p class="label">面试地点</p>
        <input class="input-area" v-model="address" placeholder="请输入面试地点"></input>
      </div>
      <div class="g-flex g-row-center g-m-t-30">
        <div class="submit-btn g-flex g-row-center" @click="doSubmit">发送邀请</div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
	import {
		Message
	} from 'element-ui';
	import {
		sendInvite
	} from "@/api/job.js"
export default {
  name: "invite-popup",
   props:['id'],
  data() {
    return {
      dialogVisible: false,
      name: '',
      phone: '',
      time: '',
      address: ''
    }
  },
  methods: {
    // 开启
    open() {
      this.dialogVisible = true
    },
    // 关闭
    close() {
      this.dialogVisible = false
    },
    // 提交
    doSubmit() {
		if(this.time==''||this.name==''||this.phone==''||this.address==''){
			Message.error("请补全信息")
			return;
		}
		this.time=this.time.toISOString().replace(/T/g,' ').replace(/\.[\d]{3}Z/,'');
		let params={
			status:1,
			resumeId:this.id,
			interviewTime:this.time,
			orgContacts:this.name,
			orgMobile:this.phone,
			orgAddress:this.address
		}
		sendInvite(params).then(res=>{
			  this.$emit('closeInvitePop',{id:this.id})
			  Message.success("邀请成功")
		})
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
  padding: 0 !important;
}

::v-deep .el-input__inner{
  background: none;
  border: none;
  padding:8px 15px 8px 0;
  height: 0!important;
  line-height: initial!important;
  color: #333!important;
}

.cut-line {
  margin: 15px 0 20px;
  background: #f7f7f7;
  height: 1px;
}

.input-row {
  .label {
    width: 20%;
    color: #999;
  }

  .input-area {
    width: 80%;
    background-color: #F6F6F8 !important;
    border: none;
    padding: 6px 15px;
    font-size: 16px;

    &:focus {
      outline: none;
    }
  }
}

.submit-btn{
  padding: 8px 32px;
}
</style>